export const studyOpportunitiesItems = {
  kidneyStones : {
    key      : 'kidneyStones',
    title    : 'Kidney stones in ADPKD',
    subTitle : `A study to determine if kidney stone disease affects the rate of disease 
              progression and to determine whether the frequency of certain antibiotic use 
              increases the risk for stone disease in ADPKD.`,
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : [
        'Ages 18-60 years old',
        'Diagnosed with ADPKD',
        'eGFR > 60 mL/min/1.73m2',
        `No use of either prebiotics or probiotics, immunosuppressive therapy, or steroid use within the
        previous 6 months`,
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : ['University of Colorado Anschutz Medical Campus, Aurora CO '],
    },
    note      : '* If traveling from out-of-state, airfare and hotel will be arranged and paid for by the study',
    learnMore : {
      title : 'Learn more',
      links : [
        'https://clinicalstudies.pkdcure.org/study/kidney-stone-in-adpkd/',
      ],
    },
  },
  octreotide : {
    key                 : 'octreotide',
    title               : 'A Study of Octreotide for Polycystic Liver Disease',
    subTitle            : 'The purpose of this trial is to evaluate the effectiveness and safety of 2 treatment regimens of CAM2029 in patients with Polycystic Liver Disease (PLD).',
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : [
        'Ages 18 and older ',
        'Diagnosis of PLD (associated with ADPKD or isolated as in ADPLD) as defined by htTLV ≥ 2500 mL/m at screening',
        'Has not had surgical intervention for PLD within 3 months before screening ',
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : [
        'Mayo Clinic, Rochester, MN',
        'The New York Presbyterian Hospital, New York NY',
        'Hospital of the University of Pennsylvania, Philadelphia, PA',
        'University of Texas Southwestern Medical Center, Dallas, TX',
      ],
    },
    learnMore : {
      title : 'Learn more',
      links : [
        'https://clinicalstudies.pkdcure.org/study/a-randomized-placebo-controlled-double-blind-multi-center-phase-2-3-trial-to-assess-efficacy-and-safety-of-octreotide-subcutaneous-depot-cam2029-in-patients-with-symptomatic-polycystic-liver-dise/',
      ],
    },
  },
  empagliflozin : {
    key                 : 'empagliflozin',
    title               : 'Study of Empagliflozin in Patients With ADPKD',
    subTitle            : 'A pilot randomized clinical trial to determine the safety and tolerability of empagliflozin in ADPKD patients. To achieve this, the investigator will conduct a 12-month parallel-group, randomized, double-blind, placebo-controlled trial in 50 ADPKD patients.',
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : [
        'Ages: 18 to 50 years old',
        'Diagnosis of ADPKD',
        'Estimated Glomerular Filtration Rate (eGFR) 30-90 ml/min/1.73m2',
        'Stable renal function over the prior 3 months',
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : [
        'University of Colorado Anschutz Medical Campus, Aurora CO',
        'University of Maryland in Baltimore',
      ],
    },
    learnMore : {
      title : 'Learn more',
      links : [
        'https://clinicalstudies.pkdcure.org/study/feasibility-of-study-of-empagliflozin-in-patients-with-adpkd/',
      ],
    },
  },
  geneticTestingInAdpk : {
    key                 : 'geneticTestingInAdpk',
    title               : 'Genetic Testing in Autosomal Dominant Polycystic Kidney Disease',
    subTitle            : 'This study is to investigate the underuse of tolvaptan and genetic testing in patients with ADPKD, focusing on racial disparities, patient perceptions, and mental health aspects of the disease to improve treatment adherence and encourage early diagnosis within families. ',
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : ['Ages 18 and older', 'Diagnosis of ADPKD'],
    },
    studyLocation : {
      title     : 'Study location',
      locations : ['San Francisco, California'],
    },
    learnMore : {
      title : 'Learn more',
      links : [
        'https://clinicalstudies.pkdcure.org/study/genetic-testing-in-autosomal-dominant-polycystic-kidney-disease/ ',
      ],
    },
  },
  zeusResearch : {
    key : 'zeusResearch',
    title :
      'ZEUS – A Research Study to Look at How Ziltivekimab Works Compared to Placebo in People With Cardiovascular Disease, Chronic Kidney Disease and Inflammation (ZEUS)',
    subTitle            : 'This study is to determine if the medication ziltivekimab reduces the risk of having cardiovascular events (for example heart attack and stroke) in people with cardiovascular disease and chronic kidney disease.',
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : [
        'Ages 18 and older',
        ['Diagnosis of Chronic Kidney Disease', 'eGFR of 15≥60 mL/min/1.73m^2', 'Urinary albumin-to-creatinine ration (UACR) greater than or equal to 200 mg/L',],
        'Evidence of atherosclerotic cardiovascular disease (ASCVD)',
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : [
        'Alabama, Arizona, Arkansas, California, Colorado, Connecticut, District of Columbia, Florida, Georgia, Idaho, Illinois, Indiana, Kansas, Kentucky, Louisiana, Maryland, Massachusetts, Michigan, Minnesota, Missouri, Nebraska, Nevada, New Jersey, New Mexico, New York, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, Wisconsin',
      ],
    },
    learnMore : {
      title : 'Learn more',
      links : [
        'https://clinicalstudies.pkdcure.org/study/zeus-a-research-study-to-look-at-how-ziltivekimab-works-compared-to-placebo-in-people-with-cardiovascular-disease-chronic-kidney-disease-and-inflammation-zeus/',
      ],
    },
  },
  rGLS8429 : {
    key                 : 'rGLS8429',
    title               : 'A Study of RGLS8429 in Patients With ADPKD',
    subTitle            : 'In this randomized, double-blind, placebo-controlled Phase 1b study, multiple doses of RGLS8429 or placebo will be administered via injection to subjects with ADPKD to evaluate the safety, tolerability, pharmacodynamics and pharmacokinetics of RGLS8429.',
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : [
        'Age: 18 to 70 years old',
        'eGFR between 30 to 90 mL/min/1.73 m2',
        'Body mass index (BMI) 18 to 35 kg/m2',
        'Class 1C, 1D, or 1E Mayo Imaging Classification of ADPKD (based upon either the MRI obtained during screening, or a prior MRI obtained within 5 years of screening with documented Mayo classification)',
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : [
        'Multiple clinical sites around the U.S. - go to the website below to see a comprehensive list.',
      ],
    },
    learnMore : {
      title : 'Learn more',
      links : [
        'https://clinicalstudies.pkdcure.org/study/a-study-of-rgls8429-in-patients-with-adpkd/',
      ],
    },
  },
  brainAneurysm : {
    key                 : 'brainAneurysm',
    title               : 'Genetics of Brain Aneurysm Formation in ADPKD',
    subTitle            : 'A study to identify genetic defects associated with brain aneurysm formation in ADPKD through phone interviews and blood or saliva collection.',
    eligibilityCriteria : {
      title    : 'Eligibility Criteria:',
      criteria : [
        'Age: 18 years or older',
        'Have been diagnosed with ADPKD',
        'Have a had confirmed brain aneurysm',
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : [
        'The study team is located at the University of Maryland in Baltimore, MD, but you can participate from anywhere!',
      ],
    },
    learnMore : {
      title : 'Learn more',
      links : [
        'https://clinicalstudies.pkdcure.org/study/genetics-of-brain-aneurysm-formation-in-autosomal-dominant-polycystic-kidney-disease/',
      ],
    },
  },
  pkdr : {
    key                 : 'pkdr',
    title               : 'Polycystic Kidney Disease Repository',
    subTitle            : 'The University of Kansas has a biorepository of blood and urine samples from adults with PKD. The goal of this repository is to provide specimens to investigators for the discovery of biomarkers that may help to monitor PKD progression and/or determine the effectiveness of new treatments.',
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : [
        'Ages 18 to 70 years old',
        'Diagnosed with PKD',
        'Has had an MRI or CT scan of the kidneys within the last 5 years',
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : ['University of Kansas Medical Center, Kansas City, KS'],
    },
    learnMore : {
      title : 'Learn more',
      links : [
        'https://clinicalstudies.pkdcure.org/study/polycystic-kidney-disease-repository/',
      ],
    },
  },
  polycysticLivers : {
    key                 : 'polycysticLivers',
    title               : 'Genetic Studies of Polycystic Livers',
    subTitle            : 'Our study will use genetic testing of people with multiple liver cysts to help explain the cause of liver and kidney cysts.  Participation requires a one-time blood sample for research genetic testing.',
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : [
        'Ages 18 and older',
        'Diagnosed with liver cysts',
        'Imaging (Ultrasound, CT Scan, or MRI) demonstrating >4 liver cysts if age >40 or any liver cysts if age <40.',
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : [
        'The study team is located at Yale University in New Haven, CT, but you can participate from anywhere!',
      ],
    },
    learnMore : {
      title : 'Learn more',
      links : [
        'https://clinicalstudies.pkdcure.org/study/genetic-studies-of-polycystic-livers/ ',
      ],
    },
  },
  tolvaptan : {
    key                 : 'tolvaptan',
    title               : 'PB to reduce increased urination related to tolvaptan',
    subTitle            : 'The purpose of this research is to study the effectiveness and safety of the medication PB in slowing the frequent urination related to tolvaptan as long-term treatment of ADPKD.',
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : [
        'Ages 18 years and older',
        'GFR ≥ 30 ml/min.',
        'Diagnosis of ADPKD',
        'Morning Uosm < 300 mOsm/kg H2O',
        'Currently taking tolvaptan',
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : ['Mayo Clinic, Jacksonville, FL'],
    },
    learnMore : {
      title : 'Learn more',
      links : ['https://clinicalstudies.pkdcure.org/study/pb-for-adpkd/'],
    },
  },
  caloricRestriction : {
    key                 : 'caloricRestriction',
    title               : 'Daily Caloric Restriction in ADPKD',
    subTitle            : 'This 2-year research study is being conducted to learn more about a behavioral weight loss program in people with ADPKD. Participants will meet in-person at the University of Colorado Anschutz Medical Campus for 3-5 hours each visit for study activities.',
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : [
        'Between 18 and 65 years old',
        'Non-smokers',
        'Not diagnosed with heart disease or diabetes',
        'BMI between 25 and 45 kg/m^2',
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : ['University of Colorado Anschutz Medical Campus, Aurora, CO'],
    },
    learnMore : {
      title : 'Learn more',
      links : [
        'https://clinicalstudies.pkdcure.org/study/daily-caloric-restriction-in-adpkd/',
      ],
    },
  },
  ADPedKD : {
    key                 : 'ADPedKD',
    title               : 'ADPedKD',
    subTitle            : 'ADPedKD is an international, longitudinal registry including ADPKD patients who were diagnosed in childhood.',
    eligibilityCriteria : {
      title    : 'Eligibility criteria (other inclusion/exclusion criteria may apply)',
      criteria : [
        'Are a male or female of any age',
        'Were diagnosed with ADPKD at the age of 19 or younger',
      ],
    },
    studyLocation : {
      title     : 'Study location',
      locations : [
        'The study team is located at Children’s National in Washington, D.C., but you can participate from anywhere!',
      ],
    },
    learnMore : {
      title : 'Learn more',
      links : ['https://clinicalstudies.pkdcure.org/study/adpedkd/'],
    },
  },
};

const getEligibility = (participantTaskEntry) => {
  const adpkd = participantTaskEntry?.haveYouBeenDiagnosedWithAdpkdByAPhysician === 'yes';
  const age = participantTaskEntry?.whatIsYourAge;
  const egf =
    participantTaskEntry?.atYourLastDoctorsVisitWhatWasYourEstimatedGlomerularFiltrationRateEGfrValueIfUnknownLeaveBlank;
  const pkdPLD =
    participantTaskEntry
      ?.haveYouEverBeenToldByYourDoctorThatYouHaveSelectAllThatApply
      ?.polycysticLiverDiseasePld;
  const receivingDialysis =
    participantTaskEntry?.areYouCurrentlyReceivingDialysis === 'no';
  const kidneyTransplant =
    participantTaskEntry?.haveYouHadAKidneyTransplant === 'no';
  const brainCerebralAneurysm =
    participantTaskEntry
      ?.haveYouEverBeenToldByYourDoctorThatYouHaveSelectAllThatApply
      ?.aBrainCerebralAneurysm;
  const liverCyst =
    participantTaskEntry?.doYouHaveAnyCystsSelectAllThatApply?.liverCysts;

  const canViewKidneyStonesOpportunity = age >= 18 && age <= 60 && egf > 60;
  const canViewOctreotideOpportunity = age >= 18 && pkdPLD;
  const canViewEmpagliflozinOpportunity =
    age >= 18 &&
    age <= 50 &&
    egf > 30 &&
    egf < 90 &&
    receivingDialysis &&
    kidneyTransplant;
  const canViewZeusResearchOpportunity = age >= 18 && egf >= 15 && egf <= 60;
  const canViewGeneticTestingInAdpkOpportunity = age >= 18 && adpkd;

  const canViewrGLS8429Opportunity =
    age >= 18 &&
    age <= 70 &&
    egf > 30 &&
    egf < 90 &&
    receivingDialysis &&
    kidneyTransplant;
  const canViewBrainAneurysmOpportunity = age >= 18 && brainCerebralAneurysm;
  const canViewpkdrOpportunity = age >= 18 && age <= 70;
  const canViewPolycysticLiversOpportunity = age >= 18 && liverCyst;
  const canViewTolvaptanOpportunity =
    age >= 18 && egf > 30 && receivingDialysis && kidneyTransplant;
  const canViewCaloricRestrictionOpportunity =
    age >= 18 && age <= 65 && receivingDialysis && kidneyTransplant;
  const canViewADPedKDOpportunity = age <= 30;

  return {
    canViewKidneyStonesOpportunity,
    canViewOctreotideOpportunity,
    canViewEmpagliflozinOpportunity,
    canViewGeneticTestingInAdpkOpportunity,
    canViewZeusResearchOpportunity,
    canViewrGLS8429Opportunity,
    canViewBrainAneurysmOpportunity,
    canViewpkdrOpportunity,
    canViewPolycysticLiversOpportunity,
    canViewTolvaptanOpportunity,
    canViewCaloricRestrictionOpportunity,
    canViewADPedKDOpportunity,
  };
};

export const getUsersOpportunities = (coreQuestionnaire) => {
  if (!coreQuestionnaire) {
    return [];
  }

  const participantTaskEntry = coreQuestionnaire?.taskEntry;
  const eligibility = getEligibility(participantTaskEntry);

  const opportuiniesObject = {
    [`${eligibility.canViewKidneyStonesOpportunity}_kidneyStones`] :
      studyOpportunitiesItems.kidneyStones,
    [`${eligibility.canViewOctreotideOpportunity}_octreotide`] :
      studyOpportunitiesItems.octreotide,
    [`${eligibility.canViewEmpagliflozinOpportunity}_empagliflozin`] :
      studyOpportunitiesItems.empagliflozin,
    [`${eligibility.canViewrGLS8429Opportunity}_rGLS8429`] :
      studyOpportunitiesItems.rGLS8429,
    [`${eligibility.canViewBrainAneurysmOpportunity}_brainAneurysm`] :
      studyOpportunitiesItems.brainAneurysm,
    [`${eligibility.canViewpkdrOpportunity}_pkdr`] :
      studyOpportunitiesItems.pkdr,
    [`${eligibility.canViewPolycysticLiversOpportunity}_polycysticLivers`] :
      studyOpportunitiesItems.polycysticLivers,
    [`${eligibility.canViewTolvaptanOpportunity}_tolvaptan`] :
      studyOpportunitiesItems.tolvaptan,
    [`${eligibility.canViewCaloricRestrictionOpportunity}_caloricRestriction`] :
      studyOpportunitiesItems.caloricRestriction,
    [`${eligibility.canViewADPedKDOpportunity}_ADPedKD`] :
      studyOpportunitiesItems.ADPedKD,
    [`${eligibility.canViewGeneticTestingInAdpkOpportunity}_geneticTesting`] :
      studyOpportunitiesItems.geneticTestingInAdpk,
    [`${eligibility.canViewZeusResearchOpportunity}_zeusResearch`] :
      studyOpportunitiesItems.zeusResearch,
  };

  const filteredOpportunies = Object.keys(opportuiniesObject).filter((result) =>
    result.includes('true')
  );
  const opportunities = filteredOpportunies.map(
    (key) => opportuiniesObject[key]
  );

  return opportunities;
};
